module.exports = __webpack_public_path__ + "img/thumb_07.3e27cd26.jpg";